module.exports = __webpack_public_path__ + "img/dinplus_iso.3e83a9e.png";